import React from "react";
import PropTypes from "prop-types";
import logo from "../../images/logoColor.svg";

import * as styles from "./LoginLogo.module.scss";

/**
 * The MyYoast logo at the top of the login, signup and password reset pages; the same logo as in the menu.
 *
 * @param {Object} props     The props.
 * @param {string} props.alt The alternative text; empty when the logo is decorative.
 *
 * @returns {ReactElement} The logo.
 */
const LoginLogo = ( { alt = "MyYoast" } ) => (
	<img className={ styles.logo } src={ logo } width="200" height="58" alt={ alt } />
);

LoginLogo.propTypes = {
	alt: PropTypes.string,
};

export default LoginLogo;
